import { useState, useEffect, useContext } from "react";
import { Context } from "./Context";

import axios from "axios";

export default function ProjectSelector(props) {
  const [projectList, setProjectList] = useState([]);
  const [projectLocList, setProjectLocList] = useState([]);
  const [enterpriseList, setEnterpriseList] = useState([]);
  const [editorList, setEditorList] = useState([]);

  const context = useContext(Context);

  function handleSubmit(event) {
    event.preventDefault();
    context.setToShow("new-job");
  }

  useEffect(() => {
    axios({
      url:
        process.env.REACT_APP_IMAGECREW_NODE_PROJ_PREFIX +
        "/api/v1/operations/get-editor-data",
      method: "get",
    })
      .then((res) => (res.status === 200 ? setEditorList(res.data) : null))
      .catch((err) => alert("server error!!!"));

    axios({
      url:
        process.env.REACT_APP_IMAGECREW_NODE_PROJ_PREFIX +
        "/api/v1/operations/get-enterprise-data",
      method: "get",
    })
      .then((res) => (res.status === 200 ? setEnterpriseList(res.data) : null))
      .catch((err) => alert("server error!!!"));
  }, []);

  useEffect(() => {
    if (context.enterprise.id) {
      axios({
        url:
          process.env.REACT_APP_IMAGECREW_NODE_PROJ_PREFIX +
          "/api/v1/operations/get-project-data?entp_id=" +
          context.enterprise.id,
        method: "get",
      })
        .then((res) => (res.status === 200 ? setProjectList(res.data) : null))
        .catch((err) => alert("server error!!!"));
    }
  }, [context.enterprise.id]);

  return (
    <>
      {context.toShow === "project-selector" ? (
        <div className="project-selector">
          <h4>{"Select Enterprise & Project"}</h4>
          <form onSubmit={handleSubmit}>
            <div className="form-inputs">
              <select
                value={context.editor}
                onChange={(e) => context.setEditor(e.target.value)}
                required
              >
                <option value="">Your Name</option>
                {editorList.map((data, idx) => (
                  <option key={idx} value={data.editor_id}>
                    {data.editor_name}
                  </option>
                ))}
              </select>
              <select
                value={context.enterprise.id}
                onChange={(e) =>
                  context.setEnterprise({
                    id: e.target.value,
                    name: e.target.options[e.target.selectedIndex].text,
                  })
                }
                required
              >
                <option value="">Select Enterprise</option>
                {enterpriseList.map((data, idx) => (
                  <option key={idx} value={data.entp_id}>
                    {data.entp_name}
                  </option>
                ))}
              </select>
              <select
                value={context.project.id}
                onChange={(e) => {
                  let project_id = e.target.value;
                  let project_name =
                    e.target.options[e.target.selectedIndex].text;
                  context.setProject({
                    id: project_id,
                    name: project_name,
                    location: "",
                  });
                  let locations = projectList[e.target.selectedIndex-1]?.project_location
                  if(locations) setProjectLocList(JSON.parse(locations));
                }}
                required
              >
                <option value="">Select Project</option>
                {projectList.map((data, idx) => (
                  <option key={idx} value={data.project_id}>
                    {data.project_name}
                  </option>
                ))}
              </select>
              <select
                value={context.project.location}
                onChange={(e) =>
                  context.setProject((prev) => {
                    return { ...prev, location: e.target.value };
                  })
                }
                required
              >
                <option value="">Select Location</option>
                {projectLocList.map((loc, idx) => (
                  <option key={idx} value={loc}>
                    {loc}
                  </option>
                ))}
              </select>
            </div>
            <div className="form-buttons">
              <button style={{ marginTop: "30px" }} type="submit">
                Create Job
              </button>
            </div>
          </form>
        </div>
      ) : null}
    </>
  );
}
